import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { Port, CreatePortDto, UpdatePortDto, StartSessionDto, RelayPortSession } from '../models/port.model';

@Injectable({
  providedIn: 'root',
})
export class PortService {
  private readonly apiUrl = `${environment.apiUrl}/ports`;

  constructor(private http: HttpClient) {}

  getPorts(relayId: string): Observable<Port[]> {
    const params = new HttpParams().set('relayId', relayId);
    return this.http.get<Port[]>(this.apiUrl, { params });
  }

  getPortById(id: string): Observable<Port> {
    return this.http.get<Port>(`${this.apiUrl}/${id}`);
  }

  createPort(dto: CreatePortDto): Observable<Port> {
    return this.http.post<Port>(this.apiUrl, dto);
  }

  updatePort(id: string, dto: UpdatePortDto): Observable<Port> {
    return this.http.put<Port>(`${this.apiUrl}/${id}`, dto);
  }

  deletePort(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  startSession(portId: string, dto: StartSessionDto): Observable<RelayPortSession> {
    return this.http.post<RelayPortSession>(
      `${environment.apiUrl}/operator/relays/ports/${portId}/session/start`,
      dto
    );
  }

  endSession(portId: string): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/operator/relays/ports/${portId}/session/end`,
      {}
    );
  }
}
